import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";

const AllotingVehicleTable = ({ myvehicleList, handleAllot, tab }) => {
  // Sort the vehicle list based on duty status
  const sortedVehicleList = [...(myvehicleList || [])].sort((a, b) => {
    // Sort by isOnDuty (true comes first)
    return b.isOnDuty - a.isOnDuty;
  });

  return (
    <TableContainer>
      {sortedVehicleList?.length ? (
        <Table aria-label="simple table" className="allridesTableMain">
          <TableHead>
            <TableRow>
              <TableCell>Model</TableCell>
              <TableCell>Vehicle No.</TableCell>
              <TableCell>Vehicle Group</TableCell>
              <TableCell>Driver</TableCell>
              <TableCell>Availability</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedVehicleList.map((data, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>
                  {data?.Vehicle?.carModel || "NA"}
                </TableCell>
                <TableCell>
                  {data?.Vehicle?.regNumber || "NA"}
                </TableCell>
                <TableCell>
                  {data?.Vehicle?.MasterCarType?.carType || "NA"}
                </TableCell>
                <TableCell>{data?.driverName || "NA"}</TableCell>
                <TableCell>
                  <Typography
                    className={data?.isOnDuty ? "colorGreen" : "colorRed"}
                    variant="caption"
                    sx={{ fontSize: '14px' }}
                  >
                    {data?.isOnDuty ? "On Duty" : "Off Duty"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <button
                    className="assignBtn cursor btnBlue"
                    onClick={() => handleAllot(data)}
                  >
                    {"Assign"}
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Box>
          <CommonNoDataFound />
        </Box>
      )}
    </TableContainer>
  );
};

export default AllotingVehicleTable;